import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';

import { UserType } from '@/app/api/users';
import { Profile } from '@/app/api/profile';
import { SessionService } from '@/app/core/services/session';
import { NamedRouter } from '@/app/core/services/named-router';

export const guestGuard: CanMatchFn = () => {
  const namedRouter = inject(NamedRouter);
  const sessionsService = inject(SessionService);

  if (sessionsService.isAuthenticated()) {
    const authUser: Profile = JSON.parse(localStorage.getItem('authUser'));

    if (!authUser) {
      namedRouter.navigate(['/auth/login']);
      return false;
    }

    if (authUser.type === UserType.Admin) {
      namedRouter.navigate(['/admin/agencies']);
      return false;
    }

    if (authUser.type === UserType.Agency) {
      namedRouter.navigate(['/agency', authUser.agency.id, 'clients']);
      return false;
    }

    namedRouter.navigate(['/client', authUser.client.id, 'campaigns']);

    return false;
  } else {
    return true;
  }
};
